var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FieldContentContainer',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.fullName,
    offset: 12,
    delay: { show: 300, hide: 100 },
    placement: 'bottom',
  }),expression:"{\n    content: fullName,\n    offset: 12,\n    delay: { show: 300, hide: 100 },\n    placement: 'bottom',\n  }"}],attrs:{"source":_vm.field.source,"has-value":_vm.isChecked,"checkbox":true,"is-required":_vm.isRequired,"show-initials":_vm.showInitials}},[(_vm.isChecked)?_c('BaseIcon',{staticClass:"checkbox-field-icon",attrs:{"icon":"check"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }